import DatabaseReference from '../platform/DatabaseReference';
import Device from './Device';

export default class Devices extends DatabaseReference {
  get childReferenceType() {
    return Device;
  }
}
